
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookEntryHunting",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "WildbuchEintragJagd",
      page: "WildbuchEintragJagdDaten",
      remoteId: "",
      

      

    });
    return {
      request
    };
  }
};
